import { AppSettings } from "../settings/AppSettings";

export class Templates {
	
	public static createElement(htmlString:string):HTMLElement {
		let template = document.createElement("template");
		htmlString = htmlString.replace(/{{r}}/g, AppSettings.resourcesPath);
		htmlString = htmlString.replace(/{{sr}}/g, AppSettings.serverRoot);
		template.innerHTML = htmlString;
		let el = template.content.firstElementChild;
		el.remove();
		return el as HTMLElement;
	}
	
	public static createDiv(htmlString:string):HTMLDivElement {
		return Templates.createElement(htmlString) as HTMLDivElement;
	}
	
	
	
	public static readonly confirmationBox:string = `
	<div class="screen-overlay cfm-overlay">
		<div class="cfm-confirmationBox dialog2" >
			<div class="dg2-content">
				<div class="cfm-message"></div>
				<div class="cfm-verification">
					<input class="cfm-verificationInput" type="text"/>
				</div>
				<div class="cfm-buttonsDiv">
					<button class='cfm-confirm-ok'>Confirm</button>
					<button class='cfm-confirm-cancel'>Cancel</button>
				</div>
			</div>
		</div>
	</div>
	`;
	
	public static readonly loadingOverlay:string = `
	<div class="ani-loadingOverlay">
		<div>
			<div class="ani-lo-pleaseWait">Please wait...</div>
			<div class="ani-lo-lds-default">
				<div></div><div></div><div></div><div></div><div></div><div></div>
				<div></div><div></div><div></div><div></div><div></div><div></div>
			</div>
		</div>
	</div>
	`;
	
	public static readonly discordVoiceDialog = `
	<div class="screen-overlay">
		<div class="discordVoiceDialog dialog">
			<div class="dialog-header">Discord Voice Chat</div>
			<div class="dialog-fields-section">
				<div class="dvd-fieldInstructionsDiv">Chatting via voice is a super fun
					way to enjoy making music together! Join our Discord and use the
					Collab Voice Chat Rooms to chat with friends! Some tips:
				</div>
				<div class="dvd-tipsDiv">
					<ul>
						<li>Share the room you pick in your session's text chat so others
							can join you.
						</li>
						<li>Mute your mic when you record and then unmute after so you can
							chat. Alternatively, use Push to Talk mode.
						</li>
						<li>New to Discord? Ask questions! The community is happy to help!
						</li>
					</ul>
				</div>
				<div class="dvd-discordLinkDiv">
					<a href="https://discord.gg/UjwCyJmexk" target="blank">
						Join our Discord chat server
					</a>
				</div>
			</div>
			<div class="dvd-buttons">
				<div><button class="dvd-closeBtn dialog-button">Close</button></div>
			</div>
		</div>
	</div>
	`;
}